<template>
    <div>
        <el-form :model="rule" :rules="rules" ref="forms" class="demo-ruleForm" label-width="120px">
            <el-form-item label="设备分享" prop="is_all">
                <el-radio-group v-model="rule.is_all" @change="handleDev">
                    <el-radio :label="true">全部设备</el-radio>
                    <el-radio :label="false">单台设备</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="!rule.is_all" label="设备编号" prop="dev_id">
                <el-button type="default" @click="openDialog">{{rule.dev_id == ''? '搜索设备':rule.dev_id}}</el-button>
            </el-form-item>
            <el-form-item label="起始日期" prop="start_time">
                <el-date-picker
                    v-model="rule.start_time"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy/MM/dd"
                    placeholder="起始日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="被分享机构" prop="to_ins_id">
                <el-button type="default" @click="ins_Dailog('to')">{{rule.to_ins_id == ''? '搜索机构':to_ins_name}}</el-button>
            </el-form-item>
            <el-form-item label="分享机构" prop="from_ins_id">
                <el-button type="default" @click="ins_Dailog('from')">{{rule.from_ins_id == ''? '搜索机构':from_ins_name}}</el-button>
            </el-form-item>
            <el-form-item label="失效时间" prop="is_forever">
                <el-radio-group v-model="rule.is_forever" @change="onPermanent">
                    <el-radio :label="true">永久有效</el-radio>
                    <el-radio :label="false">自定义</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="有效周期" prop="expire_days" v-if="!rule.is_forever">
                <el-input type="number" min="1" placeholder="请输入几天" v-model="rule.expire_days" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit">提交</el-button>
                <el-button @click="block">返回</el-button>
            </el-form-item>
        </el-form>


        <el-dialog title="搜索设备" :visible.sync="open">
            <el-row class="dialog_bar" :gutter="15">
                <el-col :span="9">
                    <el-input placeholder="设备编号" v-model="devId"></el-input>
                </el-col>
                <el-col :span="9">
                    <el-input placeholder="真实车牌" v-model="carNumber"></el-input>
                </el-col>
                <el-col :span="2">
                    <el-button type="primary" icon="el-icon-search" @click="onSearch">搜索</el-button>
                </el-col>
            </el-row>
            <el-radio-group class="radio_group_column" v-model="radio">
                <el-radio v-for="item in radioGroup" :label="item.devId">{{item.devId}} / {{item.carNumber}}</el-radio>
            </el-radio-group>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDailog">取 消</el-button>
                <el-button type="primary" @click="addRadio">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="搜索机构" :visible.sync="ins_open">
            <el-row class="dialog_bar" :gutter="15">
                <el-col :span="10">
                    <el-input placeholder="机构名称" v-model="ins_name"></el-input>
                </el-col>
                <el-col :span="3">
                    <el-button type="primary" icon="el-icon-search" @click="ins_Search">搜索</el-button>
                </el-col>
            </el-row>
            <el-radio-group class="radio_group_column" v-model="ins_radio">
                <el-radio v-for="item in ins_Group" :label="item">{{item.name}}</el-radio>
            </el-radio-group>
            <div slot="footer" class="dialog-footer">
                <el-button @click="close_ins_Dailog">取 消</el-button>
                <el-button type="primary" @click="add_ins">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            var number = (rule,value,callback) => {
                if (!/^\+?[1-9][0-9]*$/.test(value)) {
                    callback(new Error("请输入正整数"));
                } else {
                    callback();
                }
            }
            return {
                addtype:true,
                rule: {
                    dev_id: '',
                    expire_days: undefined,
                    from_ins_id: '',
                    is_all: true,
                    is_forever: true,
                    start_time: undefined,
                    to_ins_id: ''
                },
                rules: {
                    dev_id: {required: false, message: '请选择设备编号' },
                    start_time: {required: true, message: '请选择起始日期'},
                    to_ins_id: {required: true, message: '请选择被分享机构'},
                    from_ins_id: {required: true, message: '请选择分享机构'},
                    expire_days: [
                        {required: true, message: '请输入有效期天数'},
                        {validator: number,trigger:'blur'}
                    ],
                },
                open: false,
                devId: '',
                carNumber:'',
                radioGroup:[],
                radio:'',
                ins_open: false,
                ins_name:'',
                ins_Group:[],
                ins_radio:'',
                ins_type:'',
                to_ins_name:'',
                from_ins_name:''
            }
        },
        async created() {
            if(this.$route.params.id) {
                if(this.$store.state.editInfo.length == 0) {
                    this.$router.push('/jigou/share');
                }else {
                    this.addtype = false;
                    if(this.$store.state.editInfo.devId == '全部设备') {
                        this.rule.is_all = true;
                    }else {
                        this.rule.is_all = false;
                        this.rule.dev_id = this.$store.state.editInfo.devId;
                    }

                    this.rule.id = this.$store.state.editInfo.id
                    let start_time = this.$store.state.editInfo.start_time.substr(0,4)+'-'+this.$store.state.editInfo.start_time.substr(4,2)+'-'+this.$store.state.editInfo.start_time.substr(6,2)
                    this.rule.start_time = start_time
                    this.rule.to_ins_id = this.$store.state.editInfo.toInsId
                    this.rule.from_ins_id = this.$store.state.editInfo.fromInsId
                    this.to_ins_name = this.$store.state.editInfo.toInsName
                    this.from_ins_name = this.$store.state.editInfo.fromInsName
                    if(this.$store.state.editInfo.expire_days == -1) {
                        this.rule.is_forever = true;
                    }else {
                        this.rule.is_forever = false;
                        this.rule.expire_days = this.$store.state.editInfo.expire_days;
                    }
                }
            }
        },
        methods:{
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        if(this.rule.is_all) {
                            delete this.rule.dev_id
                        }else {
                            delete this.rule.is_all
                        }
                        if(this.rule.is_forever) {
                            delete this.rule.expire_days
                        }else {
                            delete this.rule.is_forever
                        }
                        if(this.addtype) {
                            this.$http.post('/manage/shared-ins/save',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/jigou/share');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }else {
                            this.$http.post('/manage/shared-ins/update',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/jigou/share');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }
                    }
                });
            },
            block() {
                this.$router.push('/jigou/share');
            },
            onSearch() {
                let formData = new FormData();
                if(this.devId != '') {
                    formData.append('devId',this.devId)
                }
                if(this.carNumber != '') {
                    formData.append('carNumber',this.carNumber)
                }
                this.$http.post('/manage/dev/search',formData).then(({data})=>{
                        this.radioGroup = data.data.records;
                    });
            },
            ins_Search() {
                if(this.ins_name != '') {
                    let formData = new FormData();
                    formData.append('name',this.ins_name);
                    this.$http.post('/manage/institution/search',formData).then(({data})=>{
                        this.ins_Group = data.data;
                    });
                }
            },
            openDialog() {
                this.open = true;
                this.devId = '';
                this.radioGroup = []
                this.radio = '';
            },
            closeDailog() {
                this.open = false;
                this.devId = '';
                this.radioGroup = []
                this.radio = '';
            },
            ins_Dailog(type) {
                this.ins_type = type;
                this.ins_open = true;
                this.ins_name = '';
                this.ins_Group = []
                this.ins_radio = '';
            },
            close_ins_Dailog() {
                this.ins_open = false;
                this.ins_name = '';
                this.ins_Group = []
                this.ins_radio = '';
            },
            addRadio() {
                this.open = false;
                this.devId = '';
                this.rule.dev_id = this.radio;
            },
            add_ins() {
                this.ins_open = false;
                this.ins_name = '';
                if(this.ins_type == 'to') {
                    this.rule.to_ins_id = this.ins_radio.id;
                    this.to_ins_name = this.ins_radio.name;
                }else {
                    this.rule.from_ins_id = this.ins_radio.id;
                    this.from_ins_name = this.ins_radio.name;
                }
            },
            handleDev() {
                this.rules.dev_id.required = !this.rule.is_all
            },
            onPermanent() {
                this.rules.expire_days.required = !this.rule.is_forever
            }
        }
    }
</script>

<style scoped>
    .dialog_bar{
        margin-bottom: 20px;
    }
    .radio_group_column{
        display: flex;
        flex-direction: column;
        margin-left: 10px;
        max-height: 300px;
        overflow-y: auto;
    }
    .radio_group_column label{
        margin-bottom: 10px;
    }
</style>